<template>
  <el-drawer
    :title="title"
    :append-to-body="appendToBoddy"
    :visible.sync="drawer"
    :with-header="true"
    size="70%"
    :before-close="handleOpenDrawer"
  >
    <el-container>
      <el-main>
        <el-row>
          <el-col>
            <el-form
              :model="dataHeader"
              label-position="left"
              size="mini"
              label-width="120px"
            >
              <el-row>
                <el-col>
                  <rabbey-table-3
                    ref="table"
                    v-loading="loading"
                    :columns="columns"
                    :data="items"
                    show-summary
                  />
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
import { formatMonto, formatDate } from "@/utils";

export default {
  name: "ClientWithoutCallingDetails",
  props: {
    appendToBoddy: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data() {
    return {
      activeColapseName: ["1"],
      personType: "",
      Option: "",
      contractNo: "",
      clientName: "",
      month: 0,
      title: "Datos de los clientes sin Visitar",
      drawer: false,
      cantidad: 0,
      PersonName: "",
      loading: false,
      items: [],
      contracsCancells: [],
      dataHeader: [],
      columns: [
        {
          prop: "Descripcion",
          label: "Descripción",
          minWidth: 500,
          fixed: true
        },
        {
          prop: "Cantidad",
          label: "Cantidad",
          minWidth: 80,
          fixed: true
        },
        {
          prop: "Precio_Unitario",
          label: "Precio por unidad",
          minWidth: 150,
          fixed: true
        },
        {
          prop: "Fecha_de_Venta",
          label: "Fecha de venta",
          minWidth: 300,
          fixed: true
        },
        {
          prop: "Fecha_Inicio",
          label: "Fecha de Inicio",
          minWidth: 300,
          fixed: true
        },
        {
          prop: "Fecha_Final",
          label: "Fecha fianal",
          minWidth: 300,
          fixed: true
        }
      ]
    };
  },
  methods: {
    formatMonto,
    formatDate,
    clearData() {
      this.contracsCancells = [];
      this.cantidad = 0;
    },
    show(props) {
      this.clientName = props.row.Nombre;
      this.contractNo = props.row.No_Contrato;
      this.dataHeader = props.row;
      let params = {
        contractNo: this.contractNo,
        companyCode: this.currentCompany
      };
      let title = "Equipos en contratos";
      let url = "/api/contracts/GetContratsDetails";
      this.title = title;

      this.drawer = true;
      this.loading = true;

      this.$http
        .get(url, { params: params })
        .then((resp) => {
          if (resp.data["Items"] !== undefined) {
            const { Items } = resp.data;
            this.items = Items;
            this.cantidad = Items.length;
          } else {
            this.items = resp.data;
            this.data = resp.data;
            resp.data.forEach((c) => {
              this.cantidad = this.cantidad + c.Cantidad;
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleOpenDrawer(done) {
      this.clearData();
      done();
    }
  }
};
</script>

<style></style>
